import React from "react";
import PropTypes from "prop-types";

const MuteIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="2 2 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="20" rx="4" />
      <path d="M3 3h14v14H3z" />
      <path
        d="M5 7.5h1.5L10 5v10l-3.5-2.5H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      >
        <path d="m13 8 3 4M16 8l-3 4" />
      </g>
    </g>
  </svg>
);
MuteIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default MuteIcon;
